import { createActions } from 'redux-actions';
import { put } from 'redux-saga/effects';
import { businessActions } from '../../business';

const actions = createActions({
  USER: {
    CHECK_INVITATION: (invitationToken, businessId) => ({ invitationToken, businessId })
  }
})

export function* checkInvitation({
  payload: {
    invitationToken,
    businessId
  }
}) {
  yield put(businessActions.business.verifyInvitation(invitationToken, businessId));
}

const configuration = {
  name: 'checkInvitation',
  action: actions,
  sagas: checkInvitation,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/checkInvitation.js